import { Injectable } from '@angular/core';
import { OCPPService } from './ocpp.service';
import { HttpClient } from '@angular/common/http';
import { TriggerMessageRequest } from '../models/TriggerMessageRequest';

@Injectable()
export class RemoteTriggerService extends OCPPService {

    private TRIGGER_MESSAGE_PATH = '/trigger-message';


    getProfileBasePath(): string {
        return '/operations/remote-trigger';
    }

    constructor(private http: HttpClient) {
        super();
    }

    public triggerMessage(data: TriggerMessageRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.TRIGGER_MESSAGE_PATH, data);
    }

}


